import { useEffect, useState } from "react";
import { Home, Coffee, CalendarDays, MapPin } from "lucide-react";
import { useLang } from "../i18n";

const scrollTo = (id) => {
  document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
};

const IDS = ["inicio", "carta", "reserva", "visitanos"];

export const V1MobileDock = () => {
  const { t } = useLang();
  const [active, setActive] = useState("inicio");

  const items = [
    { id: "inicio", label: "Deseos", Icon: Home },
    { id: "carta", label: t.nav.links.carta, Icon: Coffee },
    { id: "reserva", label: t.nav.links.reserva, Icon: CalendarDays },
    { id: "visitanos", label: t.nav.links.visitanos, Icon: MapPin },
  ];

  useEffect(() => {
    let frame = 0;
    const update = () => {
      frame = 0;
      const marker = window.innerHeight * 0.38;
      const current = IDS.map((id) => ({ id, top: document.getElementById(id)?.getBoundingClientRect().top }))
        .filter(({ top }) => Number.isFinite(top) && top <= marker)
        .sort((a, b) => b.top - a.top)[0]?.id;
      setActive(current || "inicio");
    };
    const onScroll = () => {
      if (!frame) frame = requestAnimationFrame(update);
    };
    update();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => {
      if (frame) cancelAnimationFrame(frame);
      window.removeEventListener("scroll", onScroll);
    };
  }, []);

  return (
    <nav className="v1-mobile-dock md:hidden" aria-label={t.nav.menu}>
      {items.map(({ id, label, Icon }) => (
        <button
          key={id}
          type="button"
          onClick={() => scrollTo(id)}
          aria-current={active === id ? "page" : undefined}
          className="v1-mobile-dock__item"
        >
          <Icon size={19} strokeWidth={1.7} aria-hidden="true" />
          <span>{label}</span>
        </button>
      ))}
    </nav>
  );
};
